import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DEPLOY_URL} from "../../../../deploy-url";
import {NbThemeService} from "@nebular/theme";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class TextChangeService {
  private currentTheme: string = 'default';
  private deployUrl: string;
  constructor(private http: HttpClient,
              @Inject(DEPLOY_URL) deployUrl: string,
              private themeService: NbThemeService,
              private translate: TranslateService) {
    this.deployUrl = deployUrl;
  }
  Init() {}
  public loadTexts() {
    const t = this.themeService.currentTheme || 'default';
    // Strip "-dark" suffix — copyright is the same for light/dark
    this.currentTheme = t.replace(/-dark$/, '');
  }
  public changeText(key: string, variables?: Record<string, string>): string {
    const i18nKey = 'footer.' + key + '.' + this.currentTheme;
    let change = this.translate.instant(i18nKey);
    if (change === i18nKey) { change = ''; }
    if (variables) {
      Object.keys(variables).forEach(k => {
        change = change.replace(`{${k}}`, variables[k]);
      });
    }
    return change;
  }
}
